import type { ChatBotUIConversationMessage } from "@jugl-web/domain-resources/chat-bot";
import { ChatBotMessageComponent } from "@jugl-web/domain-resources/chat-bot/components/ChatBotMessageComponent";
import { LiveChatUI } from "@jugl-web/domain-resources/chat-bot/components/LiveChatUI";
import { useAgentImageSource } from "@jugl-web/domain-resources/chat-bot/hooks/chatBotMediaSourceResolvers";
import { FC, useDeferredValue, useMemo } from "react";

interface LiveChatAppSampleConversationProps {
  agentName: string;
  agentImage: string | File;
  senderMessageBackgroundColor: string;
  agentGreeting: string;
}

export const LiveChatAppSampleConversation: FC<
  LiveChatAppSampleConversationProps
> = ({
  agentName,
  agentImage,
  senderMessageBackgroundColor,
  agentGreeting,
}) => {
  const deferredAgentName = useDeferredValue(agentName);
  const deferredAgentImage = useDeferredValue(agentImage);
  const agentImageSrc = useAgentImageSource(deferredAgentImage);

  const displayMessages = useMemo((): ChatBotUIConversationMessage[] => {
    const incoming: ChatBotUIConversationMessage = {
      id: "live-chat-preview-sample-incoming",
      type: "incoming",
      timestamp: new Date(),
      payload: { type: "text", text: agentGreeting, quickReplies: [] },
      senderName: deferredAgentName,
      senderImageUrl: agentImageSrc,
    };

    const outgoing: ChatBotUIConversationMessage = {
      id: "live-chat-preview-sample-outgoing",
      type: "outgoing",
      timestamp: new Date(),
      payload: {
        type: "text",
        text: "Hello! I would like to know more about your services",
        quickReplies: [],
      },
      senderName: "User",
      senderImageUrl: "",
    };

    return [incoming, outgoing];
  }, [agentGreeting, agentImageSrc, deferredAgentName]);

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <LiveChatUI.MessageList className="min-h-0 flex-1 py-4">
        {displayMessages.map((message, index) => {
          const isLast = index === displayMessages.length - 1;

          return (
            <ChatBotMessageComponent
              key={message.id}
              message={message}
              isLast={isLast}
              userBubbleColor={senderMessageBackgroundColor}
            />
          );
        })}
      </LiveChatUI.MessageList>
    </div>
  );
};
